<div _ngcontent-c0="" class="app-content ui basic segment container min">
    <div _ngcontent-c3="" class="root">
      <h2 _ngcontent-c3="" class="ui image header center aligned">
        <div _ngcontent-c3="" class="content">
          Reset your account password
        </div>
      </h2>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" _ngcontent-c3=""
        class="ui form" novalidate="" autocomplete="off" *ngIf="step==1">

        <app-alert></app-alert>

        <div _ngcontent-c3="" class="ui segment">
          <div _ngcontent-c3="" class="field">
            <div _ngcontent-c3="" class="ui left icon input">
              <i _ngcontent-c3="" class="user icon"></i>
              <input _ngcontent-c3="" formControlName="username" name="Username" placeholder="Username" type="text">
              <div *ngIf="(resetPasswordFormControl.username.touched || submitted) && resetPasswordFormControl.username.errors">
                <div *ngIf="resetPasswordFormControl.username.errors.required"
                  class="ui red left pointing prompt label transition visible">Username is required</div>
              </div>
            </div>
          </div>
          <button [disabled]="(resetPasswordForm.invalid || loading)" _ngcontent-c3="" class="ui fluid large primary submit button">
            <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            Reset Password
          </button>
        </div>
      </form>
<!--
      <form [formGroup]="resetPasswordForm2" (ngSubmit)="onSubmitStep2()" _ngcontent-c3=""
        class="ui form" novalidate="" autocomplete="off" *ngIf="step==2">

        <app-alert></app-alert>

        <div _ngcontent-c3="" class="ui segment">
          <div _ngcontent-c3="" class="field">
            <div _ngcontent-c3="" class="ui left icon input">
              <i _ngcontent-c3="" class="user icon"></i>
              <input _ngcontent-c3="" formControlName="username" name="Username" placeholder="Username" type="text">
              <div *ngIf="(resetPasswordFormControl.username.touched || submitted) && resetPasswordFormControl.username.errors">
                <div *ngIf="resetPasswordFormControl.username.errors.required"
                  class="ui red left pointing prompt label transition visible">Username is required</div>
              </div>
            </div>
          </div>
          <button [disabled]="(resetPasswordForm.invalid || loading)" _ngcontent-c3="" class="ui fluid large primary submit button">
            <i style="font-size:medium;" class="fa fa-spinner fa-spin" *ngIf="loading"></i>
            Reset Password
          </button>
        </div>
      </form> -->


    </div>
  </div>
